import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Field, Drawer, Loader, Select } from '@itds/elements/index.js';

import Api from '@brokerage/utils/Api';

const NewAgency = ({ onClose, show }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState([]);
  //data obj to create the new agency
  const [data, setData] = useState({
    name: '',
    imo_group: '',
    agency_type: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (name, e) => {
    const newValue = e.target.value;

    setData({ ...data, [name]: newValue });

    if (name === 'agency_type') {
      localStorage.setItem('agency_type', newValue);
    }
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      const { ...agency_payload } = data;

      window.scrollTo(0, 0);

      setLoading(true);

      Api.createAgency(agency_payload).then(response => {
        const agency = response.data;

        setLoading(false);
        onClose();
        navigate(`/agencies/${agency.id}/products`);
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button disabled={loading} inline={true} onClick={handleSave}>
          Create Agency
        </Button>
      }
      onClose={onClose}
      show={show}
      title='New Agency'
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          <Field label='Type'>
            <Select
              onChange={handleChange.bind(null, 'agency_type')}
              options={[
                { value: '', label: 'None' },
                { value: 'vive', label: 'Vive' }
              ]}
              value={data.agency_type}
            />
          </Field>
          <Field label='Name'>
            <Input
              invalid={errors.includes('name')}
              onChange={handleChange.bind(null, 'name')}
              required={true}
              value={data.name}
            />
          </Field>
          <Field label='IMO Group'>
            <Select
              onChange={handleChange.bind(null, 'imo_group')}
              options={[
                { value: '', label: 'None' },
                { value: 'ain', label: 'AIN (Advantage Insurance Network)' },
                { value: 'nba', label: 'NBA (National Brokerage Agencies)' },
                { value: 'ida', label: 'IDA (Insurance Designers America)' },
                { value: 'tma', label: 'TMA (The Marketing Alliance)' },
                { value: 'cps', label: 'CPS' },
                { value: 'lifemark_partners', label: 'Lifemark Partners' },
                { value: 'aimcor', label: 'AimcoR' },
                { value: 'nfp', label: 'NFP' },
                { value: 'bramco', label: 'Bramco' },
                { value: 'tellus', label: 'Tellus' },
                { value: 'capitas', label: 'Capitas' }
              ]}
              value={data.imo_group}
            />
          </Field>
        </>
      )}
    </Drawer>
  );
};

NewAgency.propTypes = {
  modal: PropTypes.string,
  onClose: PropTypes.func,
  setModal: PropTypes.func,
  show: PropTypes.bool
};

export default NewAgency;
